// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__1Z-lk","left":"StickyBox_left__2_9Y2","right":"StickyBox_right__zfEak"};